import { Reducer } from 'redux';
import { dashboard } from 'types';
import { toEnumString, toJSONArray } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { PartyState } = protos;

interface ServiceConfigState {
  businessDefinedStates: dashboard.BusinessDefinedState[];
  primaryStatesWithRequestInProgress: {
    [K in dashboard.PartyState]?: boolean;
  };
  textingAvailable: boolean;
  textingEnabled: boolean;
  twilioRegistering: boolean;
  businessActive: boolean;
  textMessageDefaults: dashboard.TextMessageDefault[];
  textingRequestInProgress: boolean;
}

export const initialState: ServiceConfigState = {
  businessDefinedStates: [],
  primaryStatesWithRequestInProgress: {
    [toEnumString(PartyState, PartyState.EXPECTED)]: false,
    [toEnumString(PartyState, PartyState.SEATED)]: false,
  },
  textingAvailable: false,
  textingEnabled: false,
  businessActive: false,
  twilioRegistering: false,
  textMessageDefaults: [],
  textingRequestInProgress: false,
};

const reducer: Reducer<ServiceConfigState, BaseTockAction> = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.BUSINESS_DEFINED_STATE_INSERT_STARTING:
    case AppConstants.BUSINESS_DEFINED_STATE_DELETE_STARTING:
    case AppConstants.BUSINESS_DEFINED_STATE_UPDATE_STARTING:
      return {
        ...state,
        primaryStatesWithRequestInProgress: {
          ...state.primaryStatesWithRequestInProgress,
          [action.context.primaryState]: true,
        },
      };
    case AppConstants.BUSINESS_DEFINED_STATE_INSERT_DONE:
    case AppConstants.BUSINESS_DEFINED_STATE_UPDATE_DONE:
    case AppConstants.BUSINESS_DEFINED_STATE_DELETE_DONE:
      return {
        ...state,
        businessDefinedStates: toJSONArray<dashboard.BusinessDefinedState>(payload),
        primaryStatesWithRequestInProgress: {
          ...state.primaryStatesWithRequestInProgress,
          [action.context.primaryState]: false,
        },
      };
    case AppConstants.BUSINESS_DEFINED_STATE_INSERT_FAILED:
    case AppConstants.BUSINESS_DEFINED_STATE_UPDATE_FAILED:
      return {
        ...state,
        primaryStatesWithRequestInProgress: {
          ...state.primaryStatesWithRequestInProgress,
          [action.context.primaryState]: false,
        },
      };
    case AppConstants.BUSINESS_DEFINED_STATE_LIST_FETCH_DONE:
      return {
        ...state,
        businessDefinedStates: toJSONArray<dashboard.BusinessDefinedState>(payload),
      };

    case AppConstants.TEXT_MESSAGING_CONFIG_FETCH_STARTING:
    case AppConstants.TEXT_MESSAGING_UPSERT_STARTING:
      return {
        ...state,
        textingRequestInProgress: true,
      };
    case AppConstants.TEXT_MESSAGING_CONFIG_FETCH_FAILED:
    case AppConstants.TEXT_MESSAGING_UPSERT_FAILED:
      return {
        ...state,
        textingRequestInProgress: false,
      };
    case AppConstants.TEXT_MESSAGING_CONFIG_FETCH_DONE:
    case AppConstants.TEXT_MESSAGING_UPSERT_DONE:
      return {
        ...state,
        textingAvailable: payload.textingAvailable,
        textingEnabled: payload.textingEnabled,
        textMessageDefaults: payload.textMessageDefault,
        twilioRegistering: payload.twilioRegistering,
        textingRequestInProgress: false,
        businessActive: payload.businessActive,
      };
    default:
      return state;
  }
};

export default reducer;
